import { StyleSheet } from 'react-native';
import React from "react";
import PlaceholderContainer from "./PlaceholderContainer";
import _ from 'lodash';
import { ThemedValues } from 'styles/themed'
import HelperString from 'utils/helper-string'
import { Placeholder, PlaceholderLine, PlaceholderMedia } from 'placeholders/Placeholder'

const PlaceholderBooking = ({ addTitle = false, containerStyle = {} }) => {
	
	return (
		<PlaceholderContainer
			style={ containerStyle }>
			
			{ addTitle && (
				<PlaceholderLine width={80} />
			)}
			
			{ _.map( [1, 2], item => {
				return (
					<Placeholder
						key={ HelperString.hash( 'placeholder', item ) }
						style={ staticStyles.placeholderMarginBottomMarginVertical }
						Left={ <PlaceholderMedia /> }>

						<PlaceholderLine width={80} />
						<PlaceholderLine />
						<PlaceholderLine width={30} />
					</Placeholder>
				);
			})}
		</PlaceholderContainer>
	)
}

const staticStyles = StyleSheet.create({
	placeholderMarginBottomMarginVertical: {
		marginBottom: ThemedValues.marginVertical,
	},
});

export default PlaceholderBooking
